import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AnalyticsService } from '@shared/lib/services/analytics.service';
import { SsoAuthService, SsoUser } from '@usana/ux/sso-auth';
import sensors from 'sa-sdk-javascript';

@Injectable({
  providedIn: 'root',
})
export class SensordataAnalyticsService extends AnalyticsService {
  readonly localizedEventData: { [key: string]: string };

  constructor(private readonly ssoAuthService: SsoAuthService) {
    super();
    sensors.init({
      server_url: environment.lib.sensorDataUrl,
      is_track_single_page: false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
      use_client_time: true,
      send_type: 'beacon',
      show_log: environment.lib.sensorDataLog, // 本地调试用true
      url: true,
      // 是否采集 $title 页面标题作为公共属性，1.16.5 以下版本默认是 false，1.16.5 及以上版本默认是 true。
      title: true,
      heatmap: {
        // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'not_collect',
        // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'not_collect',
      },
    });
    sensors.registerPage({
      product_line: 'sso-app',
    });

    // CN specific event data names.
    this.localizedEventData = {
      confirm: '确认登录',
      cancel: '取消登录',
    };
  }

  trackEvent(eventName: string, eventData?: any): void {
    sensors.track(eventName, eventData);
  }

  informOfIdToken(idToken: string): void {
    this.informOfUser(this.ssoAuthService.parseIdTokenJwt(idToken));
  }

  informOfUser(ssoUser: SsoUser): void {
    if (ssoUser) {
      // just to be safe
      sensors.login(ssoUser.sub);
    }
  }

  localizeEventData(eventDataName: string): string {
    return this.localizedEventData[eventDataName] || eventDataName;
  }
}
